import { Injectable } from '@angular/core';
import {
    DwContextDefinition,
    DwCustomContextBase,
    DwCustomContextDefinition
} from '@devwareapps/devware-cap';
import {
    AppMetaDataItemNames,
    FlightSchoolExaminerEntity
} from '../../../meta-data/app-meta-data.service';

export const FlightSchoolExaminerCurrentContext = 'flight-school-examiner-current-context';

@DwCustomContextDefinition({
    keyName: FlightSchoolExaminerCurrentContext,
    display: 'Flight School Examiner Current Context',
    isGlobal: false,
    parentItem: AppMetaDataItemNames.FlightSchoolExaminer
})
@Injectable()
export class FlightSchoolExaminerCurrentContextService extends DwCustomContextBase {
    setupContextDefinition(contextDef: DwContextDefinition): void {
        contextDef.getCustomContextFunction = resolvedContext =>
            resolvedContext.data as FlightSchoolExaminerEntity;
        contextDef.item = AppMetaDataItemNames.FlightSchoolExaminer;
        contextDef.useItemMetaData = true;
    }
}
